import { AbstractResource } from './AbstractResource';

export class Customers extends AbstractResource {
    async getById(customerId) {
        const { data } = await this.http.get(`/customers/${customerId}`);
        return data;
    }

    async getOverview(customerId) {
        const { data } = await this.http.get(`/customers/${customerId}/overview`);
        return data;
    }

    async fetch(params = {}) {
        const { data } = await this.http.get(`/customers`, { params });
        return data;
    }

    async export(params = {}) {
        const { data } = await this.http.get(`customers/export`, { params, responseType: 'blob' });
        return data;
    }

    async getTags() {
        const { data } = await this.http.get(`${process.env.VUE_APP_API_URL}/tag`, {
            baseURL: process.env.VUE_APP_API_URL,
        });
        return data;
    }

    async updateTags(customerId, tagsIds) {
        const { data } = await this.http.put(`/customer/${customerId}/tag`, { tag_ids: tagsIds }, {
            baseURL: process.env.VUE_APP_API_URL,
        });
        return data;
    }

    async getGatewaysProcesses(customerId) {
        const { data } = await this.http.get(`/customers/${customerId}/gateway-files/processes`);
        return data;
    }

    async getTemplates(customerId) {
        const { data } = await this.http.get(`/customer/${customerId}/template`);
        return data;
    }

    async updateTemplateConfig(customerId, templateId, configId, dto) {
        const { data } = await this.http.put(`/customer/${customerId}/template/${templateId}/configuration/${configId}`, dto);
        return data;
    }

    async removeTemplateConfig(customerId, templateId, configId) {
        const { data } = await this.http.delete(`/customer/${customerId}/template/${templateId}/configuration/${configId}`);
        return data;
    }
}